<template>
  <Teleport to="#status-messages" :disabled="!targetExists">
    <div v-if="statusMessages.length > 0" class="space-y-1 border-[1px] border-gray-200 rounded-md p-2">
      <div
        v-for="message in statusMessages"
        :key="message.id"
        class="text-xs rounded text-gray-500 flex items-center gap-1"
        :class="{
          'text-gray-500': message.type === 'loading',
          'text-green-600': message.type === 'success',
          'text-red-600': message.type === 'error'
        }"
      >
        <Loader2 v-if="message.type === 'loading'" class="w-3 h-3 animate-spin" />
        <Check v-else-if="message.type === 'success'" class="w-3 h-3" />
        <X v-else-if="message.type === 'error'" class="w-3 h-3" />
        {{ message.message }}
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Loader2, Check, X } from 'lucide-vue-next'
import { useStatusMessages } from '@/composables/useStatusMessages'

const { statusMessages } = useStatusMessages()
const targetExists = ref(false)

onMounted(() => {
  targetExists.value = !!document.getElementById('status-messages')
})
</script>